import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { LeadsFiltroService } from './leads-filtro.service';
import { LeadsService } from './leads.service';
import { FiltroDealers } from './filtro-dealer';
import { LeadsDetalheComponent } from './leads-detalhe/leads-detalhe.component';
import { IListaGrid } from './IListaLeads';
import { ServiceAppService } from './../../../security/service-app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RealPipe } from './real.pipe';
import { TelefonePipe } from './telefone.pipe';

@Component({
  selector: 'app-leads',
  templateUrl: './leads.component.html',
  styleUrls: ['./leads.component.scss'],
  providers: [RealPipe, TelefonePipe]
})
export class LeadsComponent implements OnInit {

  form: FormGroup;
  leadGrid: IListaGrid
  subscription: any;
  selecionado: object;
  selecionados = [];
  statusLead = [];
  visible: boolean = false;
  cols: any[];
  _selectedColumns: any[];
  dados: any[] = [];
  dadosUsadoNaTroca: any[] = [];
  dadosHistorico: any[] = []
  somenteFab = [
    { nome: 'Sim', valor: 'true' },
    { nome: 'Não', valor: 'false' }
  ]
  first: number = 0;
  displayRows: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  registros: any;
  loading: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  filtrosDealers: FiltroDealers;
  cargaTela: boolean;
  voltar: any = false;
  snap = this.route.snapshot.queryParamMap;
  @ViewChild('dt') dt: Table;
  @ViewChild(LeadsDetalheComponent, { static: false }) leadsDetalhe: LeadsDetalheComponent;
  @Input() filtros: any;
  colunas = [
    { field: 'cnpj', headerPt: 'CONCESSIONÁRIA CNPJ', headerEn: 'Dealer CNPJ' },
    { field: 'codDealer', headerPt: 'CONCESSIONÁRIA COD', headerEn: 'Dealer Code' },
    { field: 'nome', headerPt: 'CONCESSIONÁRIA', headerEn: 'Dealer' },
    { field: 'idLead', headerPt: 'LEAD ID', headerEn: 'Lead ID' },
    { field: 'leadDtHora', headerPt: 'LEAD DT/HORA', headerEn: 'Lead Date/Time' },
    { field: 'lead_captacao', headerPt: 'LEAD CAPTAÇÃO', headerEn: 'Lead Capture' },
    { field: 'lead_nome', headerPt: 'LEAD NOME', headerEn: 'Lead First Name' },
    { field: 'lead_sobrenome', headerPt: 'LEAD SOBRENOME', headerEn: 'Lead Last Name' },
    { field: 'leadEmail', headerPt: 'LEAD E-MAIL', headerEn: 'Lead Email' },
    { field: 'leadTelefone', headerPt: 'LEAD TELEFONE', headerEn: 'Lead Phone' },
    { field: 'leadMensagem', headerPt: 'LEAD MENSAGEM', headerEn: 'Lead Message' },
    { field: 'leadModelo', headerPt: 'LEAD MODELO', headerEn: 'Lead Model' },
    { field: 'leadVersao', headerPt: 'LEAD VERSAO', headerEn: 'Lead Version' },
    { field: 'leadStatus', headerPt: 'LEAD STATUS', headerEn: 'Lead Status' },
    { field: 'leadTemperatura', headerPt: 'LEAD TEMPERATURA', headerEn: 'Lead Temperature' },
    { field: 'leadEventoCod', headerPt: 'LEAD EVENTO COD', headerEn: 'Lead Event Code' },
    { field: 'leadEventoDtHora', headerPt: 'LEAD EVENTO DT/HORA', headerEn: 'Lead Event Date/Time' },
    { field: 'leadOrigem', headerPt: 'LEAD ORIGEM', headerEn: 'Lead Source' },
    { field: 'leadGerente', headerPt: 'LEAD GERENTE', headerEn: 'Lead Manager' },
    { field: 'leadGerenteCpf', headerPt: 'LEAD GERENTE CPF', headerEn: 'Lead Manager CPF' },
    { field: 'leadVendedor', headerPt: 'LEAD VENDEDOR', headerEn: 'Lead Seller' },
    { field: 'leadVendedorCpf', headerPt: 'LEAD VENDEDOR CPF', headerEn: 'Lead Seller CPF' },
    { field: 'utmSource', headerPt: 'LEAD utm_source', headerEn: 'Lead utm_source' },
    { field: 'utmMedium', headerPt: 'LEAD utm_medium', headerEn: 'Lead utm_medium' },
    { field: 'utmCampaign', headerPt: 'LEAD utm_campaign', headerEn: 'Lead utm_campaign' },
    { field: 'utmTerm', headerPt: 'LEAD utm_term', headerEn: 'Lead utm_term' },
    { field: 'utmContent', headerPt: 'LEAD utm_content', headerEn: 'Lead utm_content' },
    { field: 'trAndamento', headerPt: 'TR ANDAMENTO', headerEn: 'TR Progress' },
    { field: 'trQtdeInteracoes', headerPt: 'TR QTDE INTERAÇÕES', headerEn: 'TR Interactions Count' },
    { field: 'trDthrPrimeiroContato', headerPt: 'TR DT/HORA 1º CONTATO', headerEn: 'TR First Contact Date/Time' },
    { field: 'trTempoPrimeiroContato', headerPt: 'TR 1º CONTATO TEMPO', headerEn: 'TR 1st Contact Time' },
    { field: 'trPrimeiroContatoStatus', headerPt: 'TR 1º CONTATO STATUS', headerEn: 'TR 1st Contact Status' },
    { field: 'trDtProximoContato', headerPt: 'TR DT/HORA PROXIMO CONTATO', headerEn: 'TR Next Contact Date/Time' },
    { field: 'trDtAgendamento', headerPt: 'TR DT/HORA AGENDAMENTO', headerEn: 'TR Scheduling Date/Time' },
    { field: 'trDtVisita', headerPt: 'TR DT/HORA VISITA', headerEn: 'TR Visit Date/Time' },
    { field: 'trTesteDriveOfertado', headerPt: 'TR TEST-DRIVE OFERTADO?', headerEn: 'TR Test Drive Offered?' },
    { field: 'trDataTesteDrive', headerPt: 'TR DT/HORA TEST-DRIVE', headerEn: 'TR Test Drive Date/Time' },
    { field: 'propostaNum', headerPt: 'PROPOSTA NUM', headerEn: 'Proposal Number' },
    { field: 'propostaStatus', headerPt: 'PROPOSTA STATUS', headerEn: 'Proposal Status' },
    { field: 'propostaTipoVeic', headerPt: 'PROPOSTA TIPO VEÍCULO', headerEn: 'Proposal Vehicle Type' },
    { field: 'propostaCanal', headerPt: 'PROPOSTA CANAL', headerEn: 'Proposal Channel' },
    { field: 'dtProposta', headerPt: 'PROPOSTA DT/HORA', headerEn: 'Proposal Date/Time' },
    { field: 'propostaValorVenda', headerPt: 'PROPOSTA VALOR VENDA', headerEn: 'Proposal Sale Value' },
    { field: 'propostaChassi', headerPt: 'PROPOSTA CHASSI', headerEn: 'Proposal Chassis' },
    { field: 'propostaChassiUsado', headerPt: 'PROPOSTA USADO CHASSI', headerEn: 'Proposal Used Chassis' },
    { field: 'propostaUsadoTroca', headerPt: 'PROPOSTA USADO NA TROCA', headerEn: 'Proposal Trade-In Used' },
    { field: 'propostaUsadoAno', headerPt: 'PROPOSTA USADO ANO', headerEn: 'Proposal Used Year' },
    { field: 'propostaValorAvaliacao', headerPt: 'PROPOSTA VALOR AVALIAÇÃO', headerEn: 'Proposal Appraisal Value' },
    { field: 'condicaoPagamento', headerPt: 'PROPOSTA CONDIÇÃO PGMT', headerEn: 'Proposal Payment Condition' },
    { field: 'dtInsucesso', headerPt: 'PROPOSTA DT/HORA INSUCESSO', headerEn: 'Proposal Failure Date/Time' },
    { field: 'motivoInsucesso', headerPt: 'PROPOSTA MOTIVO INSUCESSO', headerEn: 'Proposal Failure Reason' },
    { field: 'nfNumero', headerPt: 'NF NUM', headerEn: 'Invoice Number' },
    { field: 'nfData', headerPt: 'NF DATA', headerEn: 'Invoice Date' },
    { field: 'nfChave', headerPt: 'NF CHAVE', headerEn: 'Invoice Key' },
    { field: 'nfTipoCliente', headerPt: 'NF TIPO CLIENTE', headerEn: 'Invoice Client Type' },
    { field: 'nfNome', headerPt: 'NF NOME', headerEn: 'Invoice First Name' },
    { field: 'nfSobrenome', headerPt: 'NF SOBRENOME', headerEn: 'Invoice Last Name' },
    { field: 'nfEmail', headerPt: 'NF E-MAIL', headerEn: 'Invoice Email' },
    { field: 'nfDddUm', headerPt: 'NF DDD 01', headerEn: 'Invoice Area Code 01' },
    { field: 'nfNumeroUm', headerPt: 'NF TELEFONE 01', headerEn: 'Invoice Phone 01' },
    { field: 'nfDddDois', headerPt: 'NF DDD 02', headerEn: 'Invoice Area Code 02' },
    { field: 'nfNumeroDois', headerPt: 'NF TELEFONE 02', headerEn: 'Invoice Phone 02' },
    { field: 'nfChassi', headerPt: 'NF CHASSI', headerEn: 'Invoice Chassis' },
    { field: 'nfModelo', headerPt: 'NF MODELO', headerEn: 'Invoice Model' },
    { field: 'nfVersao', headerPt: 'NF VERSÃO', headerEn: 'Invoice Version' },
    { field: 'nfCor', headerPt: 'NF COR', headerEn: 'Invoice Color' },
    { field: 'nfAcabamentoInterno', headerPt: 'NF ACABAMENTO INTERNO', headerEn: 'Invoice Interior Finish' },
    { field: 'nfAnoModelo', headerPt: 'NF ANO MODELO', headerEn: 'Invoice Model Year' },
    { field: 'entregaAgenda', headerPt: 'ENTREGA AGENDA', headerEn: 'Delivery Scheduled' },
    { field: 'entregaData', headerPt: 'ENTREGA DT/HORA', headerEn: 'Delivery Date/Time' },
    { field: 'emplacamentoPlaca', headerPt: 'EMPLACAMENTO PLACA', headerEn: 'License Plate' },
    { field: 'emplacamentoData', headerPt: 'EMPLACAMENTO DATA', headerEn: 'License Date' },
    { field: 'appEmailCondutor', headerPt: 'APP E-MAIL CONDUTOR', headerEn: 'Driver App Email' },
    { field: 'dataHoraOk', headerPt: '5G DT/HORA OK', headerEn: '5G Date/Time OK' },
    { field: 'servicosDataOk', headerPt: 'SERVIÇOS DT/HORA OK', headerEn: 'Services Date/Time OK' }
  ];  
  

  constructor(private service: LeadsService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: LeadsFiltroService,
    private exportExcelSerivce: ExportExcelService,
    private fb: FormBuilder,
    private serviceApp: ServiceAppService,
    private realPipe: RealPipe,
    private telefonePipe: TelefonePipe) {

    this.filtros = {};
    this.nomeModulo = 'Leads';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    if (this.snap.get('dataInic') != null) {

      this.dataInicial = moment(this.snap.get('dataInic'), 'DD-MM-YYYY').toDate();
      this.dataFinal = moment(this.snap.get('dataFim'), 'DD-MM-YYYY').toDate();
      this.filtros.dealers = this.snap.get('dealers');
      this.voltar = this.snap.get('btVoltar');

      this.form = this.fb.group({
        data_inicial: [this.snap.get('dataInic')],
        data_final: [this.snap.get('dataFim')],
        dealers: [''],
        status_Lead: [''],
        id_lead: [this.snap.get('idLead')],
        cod_evento: [''],
        modelo_veic: [''],
        versao_veic: [''],
        numeroProposta: [''],
        somente_fabrica: [''],
        id_fabrica: [''],
        tipo_evento: [''],
        origem: ['']
      });
    } else {
      this.form = this.fb.group({
        data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
        data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
        dealers: [''],
        status_Lead: [''],
        id_lead: [''],
        cod_evento: [''],
        modelo_veic: [''],
        versao_veic: [''],
        numeroProposta: [''],
        somente_fabrica: [''],
        id_fabrica: [''],
        tipo_evento: [''],
        origem: ['']
      });
    }
  }

  ngOnInit() {
    this.cargaTela = true;
    this.changeLanguageValue();
    this.preencherStatusLeads();

    this.loading = true;

    this.cols = [
      { field: 'detalhe', header: '', width: '50px' },
      { field: 'codConcessionaria', header: 'relatorioVeiculos.leads.grid.codConcessionaria', headerBr: 'Cód. Concessionária', headerGb: 'Dealership  Code', width: '150px' },
      { field: 'concessionaria', header: 'relatorioVeiculos.leads.grid.concessionaria', headerBr: 'Concessionária', headerGb: 'Dealership', width: '300px' },
      { field: 'idFabrica', header: 'relatorioVeiculos.leads.grid.idFabrica', headerBr: 'Id Fabrica', headerGb: 'Factory ID', width: '200px' },
      { field: 'codigoEventoLead', header: 'relatorioVeiculos.leads.grid.codigoEventoLead', headerBr: 'Cód. Evento', headerGb: 'Event Code', width: '140px' },
      { field: 'descTipoEvento', header: 'relatorioVeiculos.leads.detalhes.informacoes.descTipoEvento', headerBr: 'Tipo Evento', headerGb: 'Event Type', width: '150px' },
      { field: 'leadDataHora', header: 'relatorioVeiculos.leads.grid.dtLead', headerBr: 'Data/Hora Evento', headerGb: 'Event Date/Time', width: '140px' },
      { field: 'dataCriacao', header: 'relatorioVeiculos.leads.grid.dtCriacao', headerBr: 'Data/Hora Criação', headerGb: 'Date/Time Creation', width: '150px' },
      { field: 'primeiroContato', header: 'relatorioVeiculos.leads.grid.dtPrimeiroContato', headerBr: 'Data/Hora 1º contato', headerGb: 'Date/Time 1st contact', width: '170px' },
      { field: 'leadNome', header: 'relatorioVeiculos.leads.grid.nomeLead', headerBr: 'Nome', headerGb: 'First Name', width: '120px' },
      { field: 'leadSobrenome', header: 'relatorioVeiculos.leads.grid.sobrenomeLead', headerBr: 'Sobrenome', headerGb: 'Last Name', width: '200px' },
      { field: 'leadEmail', header: 'relatorioVeiculos.leads.grid.emailLead', headerBr: 'Email', headerGb: 'Email', width: '200px' },
      { field: 'leadTelefone', header: 'relatorioVeiculos.leads.grid.telefoneLead', headerBr: 'Telefone', headerGb: 'Phone', width: '150px' },
      { field: 'leadModelo', header: 'relatorioVeiculos.leads.grid.modeloLead', headerBr: 'Modelo', headerGb: 'Model', width: '125px' },
      { field: 'leadVersao', header: 'relatorioVeiculos.leads.grid.versaoLead', headerBr: 'Versão', headerGb: 'Version', width: '125px' },
      { field: 'leadStatus', header: 'relatorioVeiculos.leads.grid.statusLead', headerBr: 'Status', headerGb: 'Status', width: '130px' },
      { field: 'leadTemperatura', header: 'relatorioVeiculos.leads.grid.temperaturaLead', headerBr: 'Temperatura', headerGb: 'Temperature', width: '120px' },
      { field: 'leadGerente', header: 'relatorioVeiculos.leads.grid.gerenteLead', headerBr: 'Gerente', headerGb: 'Manager', width: '200px' },
      { field: 'leadVendedor', header: 'relatorioVeiculos.leads.grid.vendedorLead', headerBr: 'Vendedor', headerGb: 'Salesperson', width: '200px' },
      { field: 'propostaNum', header: 'relatorioVeiculos.leads.grid.numProposta', headerBr: 'Numero Proposta', headerGb: 'Proposal Number', width: '160px' }
    ];

    this._selectedColumns = this.cols;

    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private preencherStatusLeads() {
    this.statusLead = [
      { nome: '0. Pendente de Contato', valor: "0. Pendente de Contato"},
      { nome: '1. Em Contato c/ Cliente', valor: "1. Em Contato c/ Cliente"},
      { nome: '2. Cliente Agendado', valor: "2. Cliente Agendado"},
      { nome: '3. Visitou Showroom', valor: "3. Visitou Showroom"},
      { nome: '4. Test Drive Realizado', valor: "4. Test Drive Realizado"},
      { nome: '5. Proposta Aceita', valor: "5. Proposta Aceita"},
      { nome: '6. Faturado', valor: "6. Faturado"},
      { nome: '7. Entregue', valor: "7. Entregue"},
      { nome: '8. Emplacado', valor: "8. Emplacado"},
      { nome: '99. Insucesso', valor: "99. Insucesso"}
    ];
  }

  private getAll() {

    this.service.getDados('/leads/leadLista', this.f.data_inicial.value, this.f.data_final.value,
      this.f.dealers.value, this.f.status_Lead.value, this.f.cod_evento.value, this.f.modelo_veic.value,
      this.f.versao_veic.value, this.f.numeroProposta.value, this.f.id_lead.value, this.f.somente_fabrica.value, this.f.id_fabrica.value, this.f.tipo_evento.value, this.f.origem.value).subscribe(dados => {

        this.dados = dados.pedidos;
        this.registros = dados.pedidos;

        this.dados.forEach(dados => {
          if (dados.leadDataHora != null) {
            dados.leadDataHora = this.formatDateTime(new Date(dados.leadDataHora));
          }
          if (dados.dataCriacao != null) {
            dados.dataCriacao = this.formatDateTime(new Date(dados.dataCriacao));
          }
          if (dados.primeiroContato != null) {
            dados.primeiroContato = this.formatDateTime(new Date(dados.primeiroContato));
          }
          if (dados.dataHoraInsucesso != null) {
            dados.dataHoraInsucesso = this.formatDateTime(new Date(dados.dataHoraInsucesso));
          }
          if (dados.dataNF != null) {
            dados.dataNF = this.formatDateTime(new Date(dados.dataNF));
          }
          if (dados.propostaNum == 0) {
            dados.propostaNum = "";
          }
          if (dados.leadTelefone != null) {
            dados.leadTelefone = this.telefonePipe.transform(dados.leadTelefone);;
          }
        });

        this.loading = false;
        this.cargaTela = false;
      });
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.removerParametro('dataInic');
    this.removerParametro('dataFim');
    this.loading = true;
    this.displayFiltros = false;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  public getListagemComFiltros(): boolean {
    return this.f.dealers.value
      || this.dataInicial
      || this.dataFinal
      || this.f.status_Lead.value
      || this.f.cod_evento.value
      || this.f.modelo_veic.value
      || this.f.versao_veic.value
      || this.f.numeroProposta.value
      || this.f.somente_fabrica.value
      || this.f.id_fabrica.value
      || this.f.tipo_evento.value
      || this.f.origem.value
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {
    this.f.status_Lead.setValue('');
    this.f.cod_evento.setValue('');
    this.f.modelo_veic.setValue('');
    this.f.versao_veic.setValue('');
    this.f.numeroProposta.setValue('');
    this.f.somente_fabrica.setValue('');
    this.f.id_fabrica.setValue('');
    this.f.tipo_evento.setValue('');
    this.f.origem.setValue('');
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  private translateHeader(item) {
    if (item == "relatorioVeiculos.leads.grid.codConcessionaria") {
      return this.translate.currentLang === "br" ? "Cód. Concessionária" : "Dealer Code";
    }
    if (item == "relatorioVeiculos.leads.grid.concessionaria") {
      return this.translate.currentLang === "br" ? "Concessionária" : "Dealership";
    }
    if (item == "relatorioVeiculos.leads.grid.idFabrica") {
      return this.translate.currentLang === "br" ? "ID Fábrica" : "Factory ID";
    }
    if (item == "relatorioVeiculos.leads.grid.codigoEventoLead") {
      return this.translate.currentLang === "br" ? "Cód. Evento" : "Event Code";
    }
    if (item == "relatorioVeiculos.leads.detalhes.informacoes.descTipoEvento") {
      return this.translate.currentLang === "br" ? "Tipo Evento" : "Event Type";
    }
    if (item == "relatorioVeiculos.leads.grid.dtLead") {
      return this.translate.currentLang === "br" ? "Data/Hora Evento" : "Event Date/Time";
    }
    if (item == "relatorioVeiculos.leads.grid.dtPrimeiroContato") {
      return this.translate.currentLang === "br" ? "Data/Hora 1º Contato" : "Date/Time 1st Contact";
    }
    if (item == "relatorioVeiculos.leads.grid.dtCriacao") {
      return this.translate.currentLang === "br" ? "Data/Hora Criação" : "Date/Time Creation";
    }
    if (item == "relatorioVeiculos.leads.grid.nomeLead") {
      return this.translate.currentLang === "br" ? "Nome" : "First Name";
    }
    if (item == "relatorioVeiculos.leads.grid.sobrenomeLead") {
      return this.translate.currentLang === "br" ? "Sobrenome" : "Last Name";
    }
    if (item == "relatorioVeiculos.leads.grid.emailLead") {
      return this.translate.currentLang === "br" ? "Email" : "Email";
    }
    if (item == "relatorioVeiculos.leads.grid.telefoneLead") {
      return this.translate.currentLang === "br" ? "Telefone" : "Phone";
    }
    if (item == "relatorioVeiculos.leads.grid.modeloLead") {
      return this.translate.currentLang === "br" ? "Modelo" : "Model";
    }
    if (item == "relatorioVeiculos.leads.grid.versaoLead") {
      return this.translate.currentLang === "br" ? "Versão" : "Version";
    }
    if (item == "relatorioVeiculos.leads.grid.statusLead") {
      return this.translate.currentLang === "br" ? "Status" : "Status";
    }
    if (item == "relatorioVeiculos.leads.grid.temperaturaLead") {
      return this.translate.currentLang === "br" ? "Temperatura" : "Temperature";
    }
    if (item == "relatorioVeiculos.leads.grid.gerenteLead") {
      return this.translate.currentLang === "br" ? "Gerente" : "Manager";
    }
    if (item == "relatorioVeiculos.leads.grid.vendedorLead") {
      return this.translate.currentLang === "br" ? "Vendedor" : "Salesperson";
    }
    if (item == "relatorioVeiculos.leads.grid.numProposta") {
      return this.translate.currentLang === "br" ? "Numero Proposta" : "Proposal Number";
    }
  }

  protected translateField(item) {
    return item;
  }

  public exportExcel() {
    this.getAll();
    if (this.registros.length > 0) {
      this.exportExcelSerivce.nomeModulo = this.nomeModulo;
      this.exportExcelSerivce.ExportTOExcelJSON(this.registros.map(r => {
        let linha = {};

        this._selectedColumns.forEach(c => {
          if (c.field != 'detalhe') {
            linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
          }
        });

        return linha;
      }));
    }
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.loading = true;
        this.getAll();
      });
  }

  formatDateTime(value: any): string {
    let pad: Function = (val: number) => {
      return val < 10 ? '0' + val : val;
    };
    return pad(value.getDate()) + '/' + pad(value.getMonth() + 1) + '/' + value.getFullYear()
      + ' ' + pad(value.getHours()) + ':' + pad(value.getMinutes()) + ':' + pad(value.getSeconds());
  }

  retornaFecharModalDetalhe(dialog: boolean) {
    this.visible = dialog;
  }

  exibirDetalhe(dado: IListaGrid) {
    this.visible = true
    this.leadGrid = dado;
    this.getHistorico(this.leadGrid.codigoEventoLead, this.leadGrid.codConcessionaria);
    this.getUsadoNaTroca(this.leadGrid.codigoEventoLead, this.leadGrid.codConcessionaria);
  }

  public getHistorico(codEvento: number, codConcessionaria: string) {
    this.serviceApp.getDados('/leads/leadListaHistorico?codEvento=' + codEvento + '&codDealer=' + codConcessionaria).subscribe((data) => {
      data.forEach(dados => {
        if (dados.dtContato != null) {
          dados.dtContato = this.formatDateTime(new Date(dados.dtContato));
        }
      });

      this.dadosHistorico = data;
      this.leadGrid.dtPrimeiroContato = data[0].dtPrimeiroContato
      this.leadGrid.qtdeInteracoes = data[0].qtdeInteracoes;
    });
  }

  public getUsadoNaTroca(codEvento: number, codConcessionaria: string) {
    this.serviceApp.getDados('/leads/leadListaVeicTroca?codEvento=' + codEvento + '&codDealer=' + codConcessionaria).subscribe((registro) => {
      registro.forEach(dados => {
        if (dados.valorUnitVeicTroca != null) {
          dados.valorUnitVeicTroca = this.realPipe.transform(dados.valorUnitVeicTroca);
        }
      });

      this.dadosUsadoNaTroca = registro;
    });
  }

  removerParametro(nome: string): void {

    const currentParams = { ...this.route.snapshot.queryParams };
    delete currentParams[nome];

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: currentParams,
      queryParamsHandling: 'merge',
    });
  }

  voltarTela() {
    this.voltar = false
    this.router.navigate(['/veiculo/painel-leads'])
  }

  public exportFullExcel() {

    this.service.getDados('/leads/fullExcel', this.f.data_inicial.value, this.f.data_final.value,
      this.f.dealers.value, this.f.status_Lead.value, this.f.cod_evento.value, this.f.modelo_veic.value,
      this.f.versao_veic.value, this.f.numeroProposta.value, this.f.id_lead.value, this.f.somente_fabrica.value, this.f.id_fabrica.value, this.f.tipo_evento.value, this.f.origem.value).subscribe(dados => {
        
        dados.pedidos.forEach(dados => {
          const camposData = [
            'leadDtHora',
            'leadEventoDtHora',
            'trDthrPrimeiroContato',
            'trDtProximoContato',
            'trDtAgendamento',
            'trDtVisita',
            'trDataTesteDrive',
            'dtProposta',
            'dtInsucesso',
            'nfData',
            'entregaData',
            'dataHoraOk',
            'servicosDataOk'
          ];
          
          for (const campo of camposData) {
            if (dados[campo] != null) {
              dados[campo] = this.formatDateTime(new Date(dados[campo]));
            }
          }
        });

        const jsonExport = dados.pedidos.map(item => {
          const linha = {};
          this.colunas.forEach(coluna => {
            let valor = item[coluna.field];
        
            // Quebra de linha para o campo trAndamento
            if (coluna.field === 'trAndamento' && valor) {
              valor = valor.split('|').join('\n'); // substitui | por quebra de linha
            }
        
            linha[this.translateColumn(coluna.field)] = valor;
          });
          return linha;
        });
  
        this.exportExcelSerivce.nomeModulo = 'Leads Full';
        this.exportExcelSerivce.ExportTOExcelJSON(jsonExport);
      });
  }
  
  translateColumn(field: string): string {
    const coluna = this.colunas.find(c => c.field === field);
    if (!coluna) return field;
    return this.translate.currentLang === "br" ? coluna.headerPt : coluna.headerEn;
  }
  
}